import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiGrid = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiGrid'];
  defaultProps?: ComponentsProps['MuiGrid'];
  variants?: ComponentsVariants['MuiGrid'];
};

export const MuiGrid: MuiGrid = {
  defaultProps: {
    spacing: 3,
  },
};
